export const scriptCookies = {
	'es-CO': [
		{
			type: 'text/javascript',
			src: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
			charset: 'UTF-8',
			'data-domain-script': '6a8cc130-4223-4137-8059-6ef6da6b39f4',
		},
	],
	'es-BO': [
		{
			type: 'text/javascript',
			src: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
			charset: 'UTF-8',
			'data-domain-script': '30aaf4af-4526-49c8-9fa8-0d0b76412732',
		},
	],
	'es-EC': [
		{
			type: 'text/javascript',
			src: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
			charset: 'UTF-8',
			'data-domain-script': '35c53a18-4285-4311-8060-18d04eb0d6fb',
		},
	],
	'es-DO': [
		{
			type: 'text/javascript',
			src: 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js',
			charset: 'UTF-8',
			'data-domain-script': '98f39393-0822-4d71-96a5-ce2d94526730',
		},
	],
	es: [],
}
